import Vue from 'vue';
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue';
import TableNoResultFound from '@/components/TableNoResultFound.vue';

Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component('TableNoResultFound', TableNoResultFound);
Vue.component('table-no-result-found', TableNoResultFound);
